import React from "react";

import { Box, Typography, Skeleton, Divider } from "@mui/material";

function ViewBookingLoader() {
  return (
    <Box
      sx={{
        p: 1,
        border: "1px solid #E0E0E0",
        borderRadius: 2,
      }}
    >
      {/* Top section: details */}
      {[
        "Package",
        "Check-in",
        "Check-out",
        "Guests",
        "Contact Name",
        "Contact Phone",
        "Contact Email",
      ].map((label) => (
        <Box
          key={label}
          sx={{
            display: "flex",
            justifyContent: "space-between",
            mb: 1.2,
          }}
        >
          <Typography
            sx={{ fontSize: 14, fontWeight: 400 }}
            color="text.secondary"
          >
            {label}
          </Typography>
          <Skeleton width={100} height={20} />
        </Box>
      ))}

      <Divider sx={{ my: 2 }} />

      {/* Bottom section: totals */}
      {[
        { label: "Room Amount", highlight: false },
        { label: "Tax Amount", highlight: false },
        { label: "Total Amount", highlight: true },
      ].map((item) => (
        <Box
          key={item.label}
          sx={{
            display: "flex",
            justifyContent: "space-between",
            mb: 1,
          }}
        >
          <Typography
            color={item.highlight ? "primary" : "text.secondary"}
            sx={
              item.highlight
                ? { fontWeight: 600, fontSize: 14 }
                : { fontSize: 14 }
            }
          >
            {item.label}
          </Typography>
          <Skeleton width={80} height={20} />
        </Box>
      ))}
    </Box>
  );
}

export default ViewBookingLoader;
